import { jsx } from "react/jsx-runtime";
import React, { createContext } from "react";
import { node, arrayOf, oneOfType, bool, func } from "prop-types";
const FormFieldContext = createContext({});
const formFieldPropTypes = {
  children: oneOfType([arrayOf(node), node]).isRequired,
  shouldValidate: bool,
  valid: bool,
  setCharacterCount: func
};
const FormFieldProvider = ({
  children,
  shouldValidate,
  setCharacterCount,
  valid,
  ...other
}) => {
  return /* @__PURE__ */ jsx(FormFieldContext.Provider, { value: {
    shouldValidate,
    setCharacterCount,
    valid
  }, children });
};
FormFieldProvider.propTypes = formFieldPropTypes;
var FormFieldContext_default = FormFieldContext;
export {
  FormFieldProvider,
  FormFieldContext_default as default
};
